import { render, staticRenderFns } from "./prodMerchRecord.vue?vue&type=template&id=3be2231b"
import script from "./prodMerchRecord.vue?vue&type=script&lang=js"
export * from "./prodMerchRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports